import {
	PROMOTION_UPDATE_TEXTFIELD_VALUE,
	PROMOTION_ADD_PERIOD,
	PROMOTION_ADD_PERIOD_VARIANT,
	PROMOTION_UPDATE_POSITION_FIELD_VALUE,
	PROMOTION_SET,
	PROMOTION_RESET,
	PROMOTION_UPDATE_PERIOD_FIELD_VALUE,
	PROMOTION_REMOVE_VARIATION,
	PROMOTION_REMOVE_PERIOD
} from "../../constants"

export const handleState = ( name, val ) => {
	return {
		type: PROMOTION_UPDATE_TEXTFIELD_VALUE,
		payload: {
			name: name,
			value: val
		}
	};
};

export const resetPromotion = () => {
	return {
		type: PROMOTION_RESET
	};
};

export const setPromotion = ( promotion ) => {
	return {
		type: PROMOTION_SET,
		payload: {
			promotion: promotion
		}
	}
};

export const addPeriod = (period) => {
	return {
		type: PROMOTION_ADD_PERIOD,
		payload: {
			period: period
		}
	};
};

export const addPeriodVariant = ( periodKey, variant ) => {
	return {
		type: PROMOTION_ADD_PERIOD_VARIANT,
		payload: {
			period: periodKey,
			variant: variant
		}
	}
};

export const handlePositionFieldState = ( name, value, periodKey, variantKey ) => {
	return {
		type: PROMOTION_UPDATE_POSITION_FIELD_VALUE,
		payload: {
			name: name,
			value: value,
			periodKey: periodKey,
			variantKey: variantKey
		}
	}
};

export const handlePeriodFieldState = ( name, value, periodKey ) => {
	return {
		type: PROMOTION_UPDATE_PERIOD_FIELD_VALUE,
		payload: {
			name: name,
			value: value,
			periodKey: periodKey
		}
	};
};

export const removeVariation = ( periodKey, variantKey ) => {
	return {
		type: PROMOTION_REMOVE_VARIATION,
		payload: {
			periodKey: periodKey,
			variantKey: variantKey
		}
	}
};

export const deleteSinglePeriod = (period) => {
	return {
		type: PROMOTION_REMOVE_PERIOD,
		payload: {
			period: period
		},
	};
};


// WEBPACK FOOTER //
// ./src/api/promotions/actions.js